import { Scripts, ScriptType } from '@core/data-access/models/script-injector.model';
import { has, isEmpty, isNil } from 'lodash';

export const isRootUrl = (url: string): boolean => /^\/([?#].*)?$/.test(url);

export const isUrl = (url: string) =>
  /^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(url);

export const hasScript = (scripts: Scripts, scriptType: ScriptType | undefined) =>
  !isNil(scriptType) && has(scripts, scriptType) && !isEmpty(scripts[scriptType]);
